import { jsx as i } from "react/jsx-runtime";
import { TextPrimitive as r } from "./index.es799.js";
import e from "./index.es2469.js";
const l = (t) => /* @__PURE__ */ i(r, { ...t, type: "body", className: e.container, isEllipsis: !0 });
export {
  l as CellTextPrimitive
};
//# sourceMappingURL=index.es738.js.map
